import type { FormLocales } from '@quno/onboarding/src/constants/locales';
import type {
  Model,
  ModelName,
} from '@quno/onboarding/src/generator/types/Models';

export const transformModelToBlocks = (
  componentMapper: Partial<
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Record<ModelName, (props: any, locale: FormLocales, args?: any) => any>
  >,
  currentLocale: FormLocales,
  models?: Model[] | null,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  args?: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any => {
  if (!models?.length) {
    return [];
  }

  return Promise.all(
    models.map((model) => {
      return componentMapper[model?.model]?.(model, currentLocale, args);
    }),
  );
};
